// Self-contained data for the Derrick Dumaya real-estate concept website.
export const AGENT = {
  "slug": "derrick-dumaya-real-estate-concept",
  "name": "Derrick Dumaya",
  "shortName": "Derrick",
  "role": "PRC-Licensed Real Estate Broker",
  "location": "Ortigas, Pasig, Mandaluyong, San Juan & BGC",
  "theme": "metropolis",
  "media": {
    "hero": {
      "src": "/realestate/derrick-dumaya/527066861-1172222528260366-1328241633913822182-n.webp",
      "thumbnail": "/realestate/derrick-dumaya/527066861-1172222528260366-1328241633913822182-n-720.webp",
      "alt": "Balcony view across the Metro Manila skyline",
      "label": "A clear view of the right move",
      "type": "property"
    },
    "profile": {
      "src": "/realestate/derrick-dumaya/profile.webp",
      "thumbnail": "/realestate/derrick-dumaya/profile-720.webp",
      "alt": "Derrick Dumaya presenting inside a residence",
      "label": "Derrick Dumaya",
      "type": "portrait"
    },
    "gallery": [
      {
        "src": "/realestate/derrick-dumaya/486575728-1075005354648751-162754150604252173-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/486575728-1075005354648751-162754150604252173-n-720.webp",
        "alt": "Derrick property marketing graphic for a Batangas condominium",
        "label": "A sample of public property marketing",
        "type": "listing"
      },
      {
        "src": "/realestate/derrick-dumaya/491974431-1092463786236241-7620118392069131279-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/491974431-1092463786236241-7620118392069131279-n-720.webp",
        "alt": "Derrick property marketing graphic for a Rizal house",
        "label": "House-and-lot marketing experience",
        "type": "listing"
      },
      {
        "src": "/realestate/derrick-dumaya/515436979-1148977453918207-7286939614144915765-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/515436979-1148977453918207-7286939614144915765-n-720.webp",
        "alt": "Derrick Dumaya professional contact graphic",
        "label": "Direct, professional coordination",
        "type": "brand"
      },
      {
        "src": "/realestate/derrick-dumaya/516536311-17925242838066742-2404447777106338669-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/516536311-17925242838066742-2404447777106338669-n-720.webp",
        "alt": "Furnished condominium bedroom",
        "label": "Comfortable residential options",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/525830910-1172222624927023-543997487941051773-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/525830910-1172222624927023-543997487941051773-n-720.webp",
        "alt": "Modern condominium fitness room",
        "label": "Amenities considered in the shortlist",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/525918783-1172222848260334-4722818637812244588-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/525918783-1172222848260334-4722818637812244588-n-720.webp",
        "alt": "High-rise swimming pool and amenity deck",
        "label": "Spaces beyond the unit",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/526157920-1172222771593675-1344972644398565021-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/526157920-1172222771593675-1344972644398565021-n-720.webp",
        "alt": "Bright equipped condominium gym",
        "label": "Lifestyle and practical fit",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/527022424-1172222758260343-2179555902912872928-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/527022424-1172222758260343-2179555902912872928-n-720.webp",
        "alt": "Second view of a residential fitness facility",
        "label": "Comparing the full property experience",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/527332989-1172222384927047-1159819013067471387-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/527332989-1172222384927047-1159819013067471387-n-720.webp",
        "alt": "Unfurnished condominium interior",
        "label": "A blank canvas for the next resident",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/532002545-1181862847296334-4482390001551228768-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/532002545-1181862847296334-4482390001551228768-n-720.webp",
        "alt": "Open residential living area",
        "label": "Well-proportioned living spaces",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/532044647-1181862753963010-4029814549450872260-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/532044647-1181862753963010-4029814549450872260-n-720.webp",
        "alt": "Contemporary kitchen and living area",
        "label": "Practical layouts",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/616455880-1306980614784556-4402736801381065501-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/616455880-1306980614784556-4402736801381065501-n-720.webp",
        "alt": "Derrick Dumaya outdoors",
        "label": "An approachable, client-led service",
        "type": "portrait"
      },
      {
        "src": "/realestate/derrick-dumaya/779262015-1484067150409234-6019620199395164627-n.webp",
        "thumbnail": "/realestate/derrick-dumaya/779262015-1484067150409234-6019620199395164627-n-720.webp",
        "alt": "Warm furnished bedroom interior",
        "label": "Move-in-ready options",
        "type": "property"
      },
      {
        "src": "/realestate/derrick-dumaya/banner.webp",
        "thumbnail": "/realestate/derrick-dumaya/banner-720.webp",
        "alt": "Philippines Finest Homes for You banner",
        "label": "Philippines’ Finest Homes for You",
        "type": "brand"
      }
    ]
  },
  "accent": "#E09B42",
  "ink": "#101820",
  "paper": "#EEF0EC",
  "eyebrow": "Metro Manila resale · rental · relocation",
  "headline": "Find the right home—not just any listing.",
  "intro": "Objective property guidance shaped around priorities, lifestyle and long-term value, with support that continues after the keys are handed over.",
  "promise": "Measured advice. Responsive follow-through. No pressure.",
  "proof": [
    "PRC broker no. 33533",
    "12 Rentpad reviews",
    "11 five-star reviews",
    "Rentpad member since 2016"
  ],
  "audiences": [
    "Ortigas renters & owners",
    "Remote and relocating clients",
    "Resale buyers",
    "Landlords seeking reliable coordination"
  ],
  "services": [
    {
      "title": "Resale & leasing",
      "text": "Pre-owned condominium sales and long-term leasing, especially around Ortigas, Pasig and nearby business districts."
    },
    {
      "title": "Client-led shortlists",
      "text": "Recommendations based on lifestyle, work location, practical needs and financial goals—not whichever listing is easiest to close."
    },
    {
      "title": "Remote coordination",
      "text": "Viewing, paperwork and owner communication for clients managing a move or property search from elsewhere."
    },
    {
      "title": "After-move support",
      "text": "Continued help with settling-in questions and property concerns, repeatedly identified in public reviews."
    }
  ],
  "process": [
    "Understand the decision behind the move",
    "Compare carefully chosen options",
    "Coordinate viewings, documents and negotiation",
    "Follow through after move-in or closing"
  ],
  "about": "Derrick presents himself as an independent broker with a Real Estate Management background from Trinity University of Asia. His public profiles focus on resale and rental homes across Ortigas, Pasig, Mandaluyong, San Juan, Makati and BGC, with select new-development assistance when it serves the client’s goals.",
  "contact": {
    "phone": "+63 908 872 9489",
    "phoneHref": "+639088729489"
  },
  "profiles": [
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/derrickdumaya",
      "imageSource": true
    },
    {
      "label": "OnePropertee listings",
      "href": "https://onepropertee.com/realtor-derrick",
      "imageSource": true
    },
    {
      "label": "Carousell profile/listings",
      "href": "https://www.carousell.ph/u/realtor.derrick/",
      "imageSource": true
    },
    {
      "label": "Rentpad profile",
      "href": "https://rentpad.com.ph/user/derrick-dumaya/9992745221",
      "imageSource": true
    },
    {
      "label": "Existing Wix website",
      "href": "https://dhdumaya.wixsite.com/phfinesthomesforyou/about-us"
    }
  ],
  "websiteAssessment": "Priority redesign: the business is spread across a basic Wix site and several marketplace profiles, without one strong, owned destination for Derrick’s listings, process and after-sales reputation.",
  "reviewRating": 4.9,
  "reviewCount": 12,
  "reviews": [
    {
      "author": "Liberty Lizardo",
      "stars": 5,
      "summary": "Says Derrick expedited paperwork, coordinated viewings and checked in after the move, providing support throughout.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Pat Tiu",
      "stars": 5,
      "summary": "Highlights his accommodating manner and hands-on care from requirements through move-in.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Robee Calica",
      "stars": 5,
      "summary": "Describes him as honest, professional and friendly, with assistance that continued after the lease was completed.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Mike Noone (via Robee Calica)",
      "stars": 5,
      "summary": "Credits Derrick with exceptional before-, during- and after-lease support for an Ortigas rental.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Eric Galos",
      "stars": 5,
      "summary": "Says he listens, explains the unit clearly and prioritizes the person rather than simply closing a deal.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Kristine Dizon",
      "stars": 4,
      "summary": "Found him accommodating and pleasant to deal with.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Emjey Aviles",
      "stars": 5,
      "summary": "Calls him reliable and appreciates his consistent client follow-up.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Roy Miller",
      "stars": 5,
      "summary": "Praises his follow-up, conversation coordination and professional handling of a remote client’s needs.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Yvonne Joie Palma",
      "stars": 5,
      "summary": "Highlights speed, punctuality and an accommodating approach.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Rory Jorge",
      "stars": 5,
      "summary": "Commends his needs-based shortlists, responsiveness, lack of sales pressure and practical advice.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Berna Santos",
      "stars": 5,
      "summary": "Describes him as professional, easy to work with and strongly recommendable.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    },
    {
      "author": "Katrina De Jesus",
      "stars": 5,
      "summary": "Says he is professional, helpful, accommodating and a delight to work with.",
      "source": "https://rentpad.com.ph/user/derrick-dumaya/9992745221"
    }
  ],
  "sources": [
    {
      "label": "Rentpad",
      "href": "https://rentpad.com.ph/user/derrick-dumaya/9992745221",
      "note": "Current footprint, rating and all twelve review records"
    },
    {
      "label": "OnePropertee",
      "href": "https://onepropertee.com/realtor-derrick",
      "note": "PRC number and current property activity"
    },
    {
      "label": "Existing Wix website",
      "href": "https://dhdumaya.wixsite.com/phfinesthomesforyou/about-us",
      "note": "Positioning, service philosophy and website-redesign evidence"
    },
    {
      "label": "Bahay.ph",
      "href": "https://bahay.ph/agent/dhdumaya/real-estate.html",
      "note": "Education, mobile number and service locations"
    },
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/derrickdumaya",
      "note": "Professional background and image-source profile"
    }
  ]
};
